import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../views/index/Index.vue";
import Welcome from "../views/index/Welcome.vue";

import agricultureManagement from "./agricultureManagement";
import manageMain from "./manageMain";
import supplyAndDemand from "./supplyAndDemand";
import workAndEmployment from "./workAndEmployment";
import systemSetting from "./systemSetting";
import smartPark from "./smartPark";
import farmTechnology from "./farmTechnology";
import farmPolicy from "./farmPolicy";
import goodStuff from "./goodStuff";
import shareContent from "./shareContent";
import traceabilitySystem from "./traceabilitySystem";
import helpList from "./helpList";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Index,
    children: [
      {
        path: "",
        name: "养殖管理",
        component: Welcome,
      },
      ...agricultureManagement,
      ...manageMain,
      ...supplyAndDemand,
      ...workAndEmployment,
      ...systemSetting,
      ...smartPark,
      ...farmTechnology,
      ...farmPolicy,
      ...goodStuff,
      ...shareContent,
      ...traceabilitySystem,
      ...helpList,
    ],
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.fullPath.includes("/#/")) {
    window.location.href = to.fullPath;
  } else {
    next();
  }
});
// router.afterEach((to, from) => {
//   // ...
// });
export default router;
